import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { format } from '../../shared/utils/string.util';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { SapODataLinkedService } from '../linkedservice/sap-odata.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { IModel } from '../base/annotation';

@Metamodel.model({
    name: ModelConstants.sapODataDataset,
    display: [
        format(shellStringResources.ModelName_DatasetTemplate, shellStringResources.SapOData_DisplayText),
        format(shellStringResources.ModelName_DatasetsTemplate, shellStringResources.SapOData_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: SapODataLinkedService.MODEL // Linked service redefined
        }
    }
})
export class SapODataDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
